import { useEffect } from "react";
import { BrowserRouter, useLocation } from "react-router-dom";
import { AppRoutes, ScrollToTop } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import CookieBanner from "@/components/feature/CookieBanner";
import Buttonizer from "@/components/feature/Buttonizer";

function HtmlLangUpdater() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    const seg = path.split("/")[1];
    const lang = ["de", "en", "fr", "es"].includes(seg) ? seg : "en";
    document.documentElement.lang = lang;
  }, [location.pathname]);

  return null;
}

function CanonicalUpdater() {
  const location = useLocation();

  useEffect(() => {
    const canonicalUrl = `https://net-basis.net${location.pathname}`;
    let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;

    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }

    link.href = canonicalUrl;
  }, [location.pathname]);

  return null;
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <HtmlLangUpdater />
        <CanonicalUpdater />
        <ScrollToTop />
        <AppRoutes />
        <CookieBanner />
        <Buttonizer />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;